<template>
  <div class="text-left">
    <label :for="`dynamicInput-${inputData.id}`" v-html="addNbsp(getLocaleText(inputData.label))" />
    <v-combobox
      v-model="inputValue"
      solo
      flat
      :items="inputItems"
      item-value="id"
      :item-text="item => getLocaleText(item.value)"
      :filter="filter"
      auto-select-first
      :multiple="inputData.multiple"
      :error="$v.inputValue.$error"
      :class="{
        'is-valid':
          $v.inputValue.$dirty &&
          !$v.inputValue.$invalid &&
          ((!inputData.required && inputValue && inputValue.length) || inputData.required)
      }"
      return-object
      @input="event => updateValue(event)"
    >
      <template #item="{ item }">
        <v-list-item-content>
          <v-list-item-title>
            {{ getLocaleText(item.value) }}
          </v-list-item-title>
        </v-list-item-content>
      </template>
      <template #selection="{ item }">
        <div class="v-select__selection v-select__selection--comma">
          {{ getLocaleText(item.value) }}
        </div>
      </template>
    </v-combobox>
  </div>
</template>

<script>
import formGtm from '@/mixins/formGtm';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'UlComboBox',
  mixins: [formGtm],
  props: {
    inputData: {
      type: Object,
      required: true
    },
    errorText: {
      type: String,
      default: ''
    },
    parentValueId: {
      type: Number,
      default: null
    },
    stepId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      inputValue: ''
    };
  },
  validations() {
    let validation = { inputValue: {} };
    if (this.inputData.required) {
      validation.inputValue = { required };
    }
    return validation;
  },
  computed: {
    responses() {
      return this.$store.getters[`dynamicForms/responses`];
    },
    inputItems() {
      let values = [...this.inputData.values];
      if (!this.inputData.sortValues) {
        return values;
      }

      return this.sortValues(values);
    }
  },
  created() {
    this.$eventHub.$on(`validateInput_${this.inputData.id}_${this.stepId}`, () => this.validate());
    this.$eventHub.$on(`resetValidationInput_${this.inputData.id}_${this.stepId}`, () =>
      this.reset()
    );

    this.reset();
  },
  destroyed() {
    this.$eventHub.$off(`validateInput_${this.inputData.id}_${this.stepId}`);
    this.$eventHub.$off(`resetValidationInput_${this.inputData.id}_${this.stepId}`);
  },
  methods: {
    filter(item, queryText, itemText) {
      return (
        itemText
          .normalize('NFD')
          .replace(/\p{Diacritic}/gu, '')
          .toLowerCase()
          .indexOf(
            queryText
              .normalize('NFD')
              .replace(/\p{Diacritic}/gu, '')
              .toLowerCase()
          ) !== -1
      );
    },
    validate() {
      this.$v.$touch();
      this.$store.commit('dynamicForms/updateValidation', {
        id: this.inputData.id,
        value: !this.$v.$invalid,
        formName: this.formName
      });
    },
    reset() {
      this.$v.$reset();
    },
    updateValue() {
      this.validate();
      const updateResponsePayload = {
        id: this.inputData.id,
        value: this.inputValue?.id,
        formName: this.formName
      };
      this.$store.dispatch('dynamicForms/updateResponse', updateResponsePayload);
      this.$emit('update:value');
    }
  }
};
</script>
